/*=========================================================================================
  File Name: globalComponents.js
  Description: Here you can register components globally
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from 'vue'
import VxTooltip from '@/components/generic/VxTooltip.vue'
import VxCard from '../components/vx-card/VxCard.vue'
import VxList from '../components/vx-list/VxList.vue'
import VxBreadcrumb from '../layouts/components/VxBreadcrumb.vue'
import FeatherIcon from '../components/FeatherIcon.vue'
import VxSpinner from '../components/generic/VxSpinner.vue'
import VxInputGroup from '../components/vx-input-group/VxInputGroup.vue'
import CompnowLogo from '../components/logos/CompnowLogo'
import VxScrollTrigger from '../components/generic/VxScrollTrigger.vue'
import VxElasticSuggest from '@/components/generic/VxElasticSuggest.vue'
import VxUnitInput from '@/components/generic/VxUnitInput.vue'
import VxCurrencyInput from '@/components/generic/VxCurrencyInput.vue'
import VxCalendarInput from '@/components/generic/VxCalendarInput.vue'
import VxSelect from '@/components/generic/VxSelect.vue'
import VxFileUpload from '@/components/generic/VxFileUpload.vue'
import VxDynamicForm from '@/components/generic/VxDynamicForm.vue'
import VxTextarea from '@/components/generic/VxTextarea.vue'
import VxActionIcon from '@/components/generic/VxActionIcon.vue'
import VxImageSet from '@/components/generic/VxImageSet.vue'
import VxUploadPopup from '@/components/generic/VxUploadPopup.vue'
import VxResourceSet from '@/components/generic/VxResourceSet.vue'
import VxScrollArea from '@/components/generic/VxScrollArea.vue'
import VxImagePreview from '@/components/generic/VxImagePreview.vue'
import VxSidebar from '@/components/generic/VxSidebar.vue'
import VxCalendarIcon from '@/components/generic/VxCalendarIcon.vue'
import VxMultiSearchBar from '@/components/generic/VxMultiSearchBar.vue'
import VxListAggregator from '@/components/generic/VxListAggregator.vue'
import VxTableSuggest from '@/components/generic/VxTableSuggest.vue'
import VxPhoneInput from '@/components/generic/VxPhoneInput.vue'
import VxDropDown from '@/components/generic/VxDropDown.vue'
import VxCarousel from '@/components/generic/VxCarousel.vue'
import VxSpanSelect from '@/components/generic/VxSpanSelect.vue'
import VxInput from '@/components/generic/VxInput.vue'
import VxEmailInput from '@/components/generic/VxEmailInput.vue'
import VxRadio from '@/components/generic/VxRadio.vue'
import VxBasicIcon from '@/components/generic/VxBasicIcon.vue'
import VxServerSideTable from '@/components/generic/VxServerSideTable.vue'
import VxPlaceSearch from '@/components/generic/VxPlaceSearch.vue'
import VxEmail from '@/components/generic/VxEmail.vue'
import VxPhone from '@/components/generic/VxPhone.vue'
import VxWebLink from '@/components/generic/VxWebLink.vue'
import VxBackButton from '@/components/generic/VxBackButton.vue'
import VxPagination from '@/components/generic/VxPagination.vue'
import VxCheckbox from '@/components/generic/VxCheckbox.vue'
import VxStatisticBadge from '@/components/generic/VxStatisticBadge.vue'
import VxProgress from '@/components/generic/VxProgress.vue'
import VxMilestoneProgress from '@/components/generic/VxMilestoneProgress.vue'
import VxInfoTitle from '@/components/generic/VxInfoTitle.vue'
import VxDateRangeInput from '@/components/generic/VxDateRangeInput.vue'
import VxSpoiler from '@/components/generic/VxSpoiler.vue'
import VxTabs from '@/components/generic/VxTabs.vue'
import VxAvatar from '@/components/generic/VxAvatar.vue'
import VxTagBox from '@/components/generic/VxTagBox.vue'
import VxSlideButton from '@/components/generic/VxSlideButton.vue'
import VxDateRangeDropdown from '@/components/generic/VxDateRangeDropdown.vue'
import VxDateDropdown from '@/components/generic/VxDateDropdown.vue'
import VxOutput from '@/components/generic/VxOutput.vue'

Vue.component(VxInput.name, VxInput)
Vue.component(VxTooltip.name, VxTooltip)
Vue.component(VxCard.name, VxCard)
Vue.component(VxList.name, VxList)
Vue.component(VxBreadcrumb.name, VxBreadcrumb)
Vue.component(FeatherIcon.name, FeatherIcon)
Vue.component(VxInputGroup.name, VxInputGroup)
Vue.component(VxSpinner.name, VxSpinner)
Vue.component(CompnowLogo.name, CompnowLogo)
Vue.component(VxScrollTrigger.name, VxScrollTrigger)
Vue.component(VxElasticSuggest.name, VxElasticSuggest)
Vue.component(VxUnitInput.name, VxUnitInput)
Vue.component(VxCurrencyInput.name, VxCurrencyInput)
Vue.component(VxCalendarInput.name, VxCalendarInput)
Vue.component(VxSelect.name, VxSelect)
Vue.component(VxFileUpload.name, VxFileUpload)
Vue.component(VxDynamicForm.name, VxDynamicForm)
Vue.component(VxTextarea.name, VxTextarea)
Vue.component(VxActionIcon.name, VxActionIcon)
Vue.component(VxImageSet.name, VxImageSet)
Vue.component(VxUploadPopup.name, VxUploadPopup)
Vue.component(VxResourceSet.name, VxResourceSet)
Vue.component(VxScrollArea.name, VxScrollArea)
Vue.component(VxImagePreview.name, VxImagePreview)
Vue.component(VxSidebar.name, VxSidebar)
Vue.component(VxCalendarIcon.name, VxCalendarIcon)
Vue.component(VxMultiSearchBar.name, VxMultiSearchBar)
Vue.component(VxListAggregator.name, VxListAggregator)
Vue.component(VxTableSuggest.name, VxTableSuggest)
Vue.component(VxPhoneInput.name, VxPhoneInput)
Vue.component(VxDropDown.name, VxDropDown)
Vue.component(VxCarousel.name, VxCarousel)
Vue.component(VxSpanSelect.name, VxSpanSelect)
Vue.component(VxEmailInput.name, VxEmailInput)
Vue.component(VxRadio.name, VxRadio)
Vue.component(VxBasicIcon.name, VxBasicIcon)
Vue.component(VxServerSideTable.name, VxServerSideTable)
Vue.component(VxPlaceSearch.name, VxPlaceSearch)
Vue.component(VxEmail.name, VxEmail)
Vue.component(VxPhone.name, VxPhone)
Vue.component(VxWebLink.name, VxWebLink)
Vue.component(VxBackButton.name, VxBackButton)
Vue.component(VxPagination.name, VxPagination)
Vue.component(VxCheckbox.name, VxCheckbox)
Vue.component(VxStatisticBadge.name, VxStatisticBadge)
Vue.component(VxProgress.name, VxProgress)
Vue.component(VxMilestoneProgress.name, VxMilestoneProgress)
Vue.component(VxInfoTitle.name, VxInfoTitle)
Vue.component(VxDateRangeInput.name, VxDateRangeInput)
Vue.component(VxSpoiler.name, VxSpoiler)
Vue.component(VxTabs.name, VxTabs)
Vue.component(VxAvatar.name, VxAvatar)
Vue.component(VxTagBox.name, VxTagBox)
Vue.component(VxSlideButton.name, VxSlideButton)
Vue.component(VxDateRangeDropdown.name, VxDateRangeDropdown)
Vue.component(VxDateDropdown.name, VxDateDropdown)
Vue.component(VxOutput.name, VxOutput)

// v-select component
import vSelect from 'vue-select'

// Set the components prop default to return our fresh components
vSelect.props.components.default = () => ({
    Deselect: {
        render: (createElement) =>
            createElement('feather-icon', {
                props: {
                    icon: 'XIcon',
                    svgClasses: 'w-4 h-4 mt-1'
                }
            })
    },
    OpenIndicator: {
        render: (createElement) =>
            createElement('feather-icon', {
                props: {
                    icon: 'ChevronDownIcon',
                    svgClasses: 'w-5 h-5'
                }
            })
    }
})

Vue.component(vSelect)
